// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__v4d3z","col":"styles_col__1IFis"};